import Repository from "./Repository";
import { CompaniesList, Company } from "./types/Companies";
const resource = "/companies";

export default {
  get() {
    return Repository.get<CompaniesList>(`${resource}`);
  },
  list() {
    return Repository.get<CompaniesList>(`${resource}/list`);
  },
  createCompany(company: Partial<Company>) {
    return Repository.post(`${resource}`, company);
  },
  getCompany(companyId: string) {
    return Repository.get<Company>(`${resource}/${companyId}`);
  },
  updateCompany(companyId: string, company: Partial<Company>) {
    return Repository.patch(`${resource}/${companyId}`, company);
  },
};
